<template>
  <input type="text" :value="value" ref="autocompleteText" @input="$emit('input', $event.target.value)" />
</template>

<script>
export default {
  name: 'autocompleteInput',
  props: {
    value: null,
    ajaxUrl: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.loadAutocomplete();
  },
  methods: {
    loadAutocomplete() {
      if (!this.ajaxUrl) return console.log("autocompleteInput: BISOGNA SPECIFICARE L'URL");

      var cache = {};
      $(this.$refs.autocompleteText).autocomplete({
        minLength: 4,
        source: (request, response) => {
          const term = request.term;
          if (term in cache) {
            response(cache[term]);
            return;
          }

          $.getJSON(this.ajaxUrl, request, (data, status, xhr) => {
            cache[term] = data;
            response(data);
          });
        },
        select: (event, ui) => {
          if (ui.item) this.$emit('input', ui.item.label);
        },
      });
    },
  },
};
</script>
<style lang="scss">
.ui-autocomplete {
  max-height: 200px;
  overflow-y: auto;
  /* prevent horizontal scrollbar */
  overflow-x: hidden;
}
</style>
